import React from 'react';
import { Box, Typography, Link, IconButton, useTheme } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { Link as RouterLink } from 'react-router-dom';

const footerLinks = [
  { label: 'About Us', path: '/about-us' },
  { label: 'Programs', path: '/programs' },
  { label: 'Locations', path: '/locations' },
  { label: 'Gallery', path: '/gallery' },
  { label: 'Bookings', path: '/bookings' },
  { label: 'Contact Us', path: '/contact-us' },
  { label: 'Policies', path: '/policies' },
];

const Footer = () => {
  const theme = useTheme();

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        borderTop: `1px solid ${theme.palette.divider}`,
        pt: 5,
        pb: 3,
        textAlign: 'center',
      }}
    >
      {/* Logo */}
      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
        <Link component={RouterLink} to="/">
          <Box
            component="img"
            src="/images/SJ_SWIMMING_White_Red.png"
            alt="SJ Swimming"
            sx={{ height: 44, width: 'auto' }}
          />
        </Link>
      </Box>

      {/* Footer Nav Links */}
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          gap: { xs: 1.5, sm: 3 },
          mb: 3,
          px: 2,
        }}
      >
        {footerLinks.map((item) => (
          <Link
            key={item.path}
            component={RouterLink}
            to={item.path}
            sx={{
              color: theme.palette.text.secondary,
              textDecoration: 'none',
              fontSize: '0.9rem',
              fontFamily: theme.typography.fontFamily,
              transition: 'color 0.2s',
              '&:hover': { color: theme.palette.primary.main },
            }}
          >
            {item.label}
          </Link>
        ))}
      </Box>

      {/* Social Icons */}
      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1, mb: 3 }}>
        <IconButton
          href="https://www.facebook.com/profile.php?id=61566915663384"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="SJ Swimming Facebook"
          sx={{
            color: theme.palette.text.secondary,
            '&:hover': { color: theme.palette.primary.main },
          }}
        >
          <FacebookIcon />
        </IconButton>
        <IconButton
          href="https://www.linkedin.com/company/sj-swimming/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="SJ Swimming LinkedIn"
          sx={{
            color: theme.palette.text.secondary,
            '&:hover': { color: theme.palette.primary.main },
          }}
        >
          <LinkedInIcon />
        </IconButton>
      </Box>

      {/* Copyright */}
      <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
        © {new Date().getFullYear()} SJ Swimming. All rights reserved.
      </Typography>
    </Box>
  );
};

export default Footer;
